import PropTypes from 'prop-types';

import styles from './CalendarDateSlot.scss';

export const CalendarDateSlot = ({ day, isChecked, isDisabled }) => (
  <span
    data-testid={isDisabled ? 'unavailable' : 'available'}
    className={`${styles.Calendar__slot} ${isChecked ? styles.Calendar__date_slot_selected : ''} ${isDisabled ? styles.Calendar__date_slot_disabled : ''}`}
  >
    {day}
    {isDisabled ? (
      <svg width="100%" height="100%">
        <line y2="0" x2="100%" y1="100%" x1="0" strokeWidth="1" fill="none" />
      </svg>
    ) : null}
  </span>
);

CalendarDateSlot.propTypes = {
  day: PropTypes.number.isRequired,
  isChecked: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
};
